import {useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {showToast} from '@chekinapp/ui';
import {TRUSTED_OAUTH_ORIGINS} from 'utils/constants';
import {useGoogleOAuthCallbackMutation} from 'hooks/auth/useGoogleOAuthCallbackMutation';
import {AuthPageLoader} from 'pages/Auth/components/AuthPageLoader';

const getOpenerOrigin = (returnOrigin?: string | null) =>
  returnOrigin && TRUSTED_OAUTH_ORIGINS.includes(returnOrigin)
    ? returnOrigin
    : window.location.origin;

function OAuthCallback() {
  const {t} = useTranslation();
  const [searchParams] = useSearchParams();
  const state = searchParams.get('state');
  const code = searchParams.get('code');
  const [stateText, setStateText] = useState('');

  const {mutate: oauthGoogleCallback} = useGoogleOAuthCallbackMutation({
    onSuccess: data => {
      window.opener?.postMessage(
        {isLoginSuccessful: true, accessToken: data.access_token},
        getOpenerOrigin(data.return_origin),
      );
      setStateText(t('auth.oauth_tab_success'));
      window.close();
    },
    onError: error => {
      window.opener?.postMessage(
        {isLoginError: true, error: String(error)},
        getOpenerOrigin(),
      );
      setStateText(t('auth.oauth_tab_error'));
      window.close();
    },
  });

  useEffect(() => {
    if (state && code) {
      oauthGoogleCallback({code, state});
      return;
    }

    showToast.error(t('something_went_wrong'));
  }, [state, code, oauthGoogleCallback, t]);

  if (!state || !code) {
    return <AuthPageLoader />;
  }

  return (
    <p className="p-4 text-center text-sm text-[var(--chekin-color-brand-navy)]">
      {stateText}
    </p>
  );
}

export {OAuthCallback};
